import { render } from "./QuestionnaireCardRow.vue?vue&type=template&id=8442c1a4&scoped=true"
import script from "./QuestionnaireCardRow.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCardRow.vue?vue&type=script&lang=js"

import "./QuestionnaireCardRow.vue?vue&type=style&index=0&id=8442c1a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8442c1a4"]])

export default __exports__